import React from 'react';
import PropTypes from 'prop-types';

export default function TableHeader({ setColumnOrder, columnOrder }) {
    return (
        <>
            <tr className='table-head'>
                <th className="text-center" style={{minWidth: '120px'}}>
                    Fecha<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="mov_date"
                    />
                </th>
                <th className="text-center" style={{minWidth: '120px'}}>
                    No Docto<br />
                </th>
                <th className="text-center" style={{minWidth: '100px'}} colSpan='2'>
                    Detalle<br />
                </th>
                
                <th className="text-center" style={{minWidth: '80px'}}>
                    Cargos<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="venta_neta"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Abonos<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="cobros"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    saldo
                </th>
            </tr>
        </>
    );
}

TableHeader.propTypes = {
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};

const ArrowsOrder = ({ setColumnOrder, column, columnOrder }) => {
    
    const isArrowDownActive = (columnOrder.column === column && columnOrder.order === 'desc');
    const isArrowUpActive = (columnOrder.column === column && columnOrder.order === 'asc');

    return (
        <span className="order arrows-order">
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'desc'
                })}
                className={`dropdown arrows-order__asc ${ isArrowDownActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'asc'
                })}
                className={`dropup arrows-order__desc ${isArrowUpActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
        </span>
    )
}

ArrowsOrder.propTypes = {
    column: PropTypes.string,
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};